
import { Link, useNavigate } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { Separator } from "./ui/separator";

export const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-[#0077bb] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo Section */}
          <div className="space-y-4">
            <img 
              src="https://dynamico.cloud/assets/img/logos/miniLogo.svg" 
              alt="Dynamico Logo" 
              className="h-12"
            />
            <div className="space-y-2 text-left">
              <h3 className="font-semibold text-white">Keep In Touch</h3>
              <div className="text-white/90">
                <p>info@dynamico.com</p>
              </div>
            </div>
          </div>

          {/* Company Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-white">Company</h3>
            <div className="flex flex-col space-y-2">
              <a
                href="/privacy"
                className="text-white/90 hover:text-white flex items-center gap-2"
                onClick={handleNavigation('/privacy')}
              >
                Data Privacy <ExternalLink className="h-4 w-4" />
              </a>
              <a
                href="/terms"
                className="text-white/90 hover:text-white flex items-center gap-2"
                onClick={handleNavigation('/terms')}
              >
                Terms of Use <ExternalLink className="h-4 w-4" />
              </a>
              <a
                href="/faqs"
                className="text-white/90 hover:text-white flex items-center gap-2"
                onClick={handleNavigation('/faqs')}
              >
                FAQs <ExternalLink className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Partners Section */}
          <div className="space-y-4">
            <h3 className="font-semibold text-white">Partners</h3>
            <div className="flex flex-col space-y-2">
              <a
                href="/partners"
                className="text-white/90 hover:text-white flex items-center gap-2"
                onClick={handleNavigation('/partners')}
              >
                Partner Programs <ExternalLink className="h-4 w-4" />
              </a>
              <a
                href="/request-demo"
                className="text-white/90 hover:text-white flex items-center gap-2"
                onClick={handleNavigation('/request-demo')}
              >
                Contact Us <ExternalLink className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-white/10" />

        <div className="text-center text-white/70 text-sm">
          © {new Date().getFullYear()} Dynamico. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

